export namespace XeroxMessages {
  export const USER_INFORMING = {
    BAD_OR_SAD: {
      BAD_USER_DATA: 'مشکل در دریافت و استفاده از اطلاعات کاربر',
      BAD_REQUEST: 'درخواست ارسالی شما با مشکل مواجه شد',
      TIME_OUT:
        'تعداد در خواست های شما بیشتر از تعداد مجاز است لطفا، چند دقیقه بعد دوباره تلاش کنید.',
    },
    DONE_BEFORE: {
      USER_ACTIVATED_BEFORE: 'شما اکانت خود را از قبل فعال کرده اید.',
    },
    CAN_NOT: {
      CAN_NOT_USE_PHONE_NUMBER:
        'شما امکان استفاده از این شماره تلفن را ندارید.',
    },
  };

  export const USER_AUTHORIZATION = {
    informing: {
      PLEASE_LOGIN: 'لطفا وارد سایت شوید.',
      USER_EXISTS: 'کاربری با این اطلاعات وجود دارد',
    },

    success: {
      SUCCESS_LOGIN: 'شما با موفقیت وارد سایت شدید !',
      SUCCESS_REGISTRATION:
        'ثبت نام شما با موفقیت انجام شد لطفا وارد سایت شوید',
    },

    failure: {
      UNSUCCESSFUL_REGISTRATION: 'مشکل در ثبت نام',
      UNKNOWN_UNAUTHORIZED: 'مشکل احراز هویتی ناشناخته !',
      UNAUTHORIZED: 'شماره تلفن یا رمز عبور درست نیست',
    },
  };

  export const USER_UPDATE = {
    success: {
      SUCCESS_UPDATED: 'کاربر با موفقیت بروز رسانی شد.',
      PHONE_SUCCESS_UPDATE: 'تلفن همراه شما با موفقیت تغییر یافت',
      SUCCESS_USER_PASSWORD_CHANGE: 'رمز عبور شما با موفقیت تقییر کرد',
    },

    failure: {
      NOT_UPDATED: 'مشکل در بروزرسانی اطلاعات کاربر.',
    },
  };

  export const FILE = {
    success: {
      FILE_UPLOAD: 'فایل با موفقیت آپلود شد.',
    },
    failure: {
      FILE_UPLOAD_WITH_ERROR: 'مشکل در آپلود و دریافت اطلاعات فایل شما از سرور',
      FILE_TYPE_NOT_ACCEPTED: 'فرمت فایل انتخابی شما قابل قبول نیست.',
      FILE_INPUT_EMPTY: 'ورودی فایل خالی است لطفا یک فایل انتخاب کنید',
    },
  };

  export const ORDER = {
    BINDING: {
      FAILURE: {
        BINDINGS_BIGGER_THAN_COPIES:
          'تعداد صحافی های انتخابی نباید از تعداد نسخه های شما بیشتر باشد',
      },
    },
  };
}
